// extracted by mini-css-extract-plugin
module.exports = {"container":"closable-text_container_1dUFw","icon":"closable-text_icon_14R2H","text":"closable-text_text_1GTSa","close":"closable-text_close_2VbKW"};